<section class="cont-address-navbar">
  <div class="cont-address" *ngIf="!customerCall">
    <img class="address-icon" [ngClass]="{'ico-christmas': christmas}" [src]="(!icon) ? '/assets/svg/address.svg' : icon"  alt="direcciones del usuario">
    <address class="address color-blue">{{address ? address.address : 'Seleccione'}}</address>
    <app-icons [color]="'#418fde'"></app-icons>
  </div>
  <div class="cont-callcenter" *ngIf="customerCall">
    <p class="user-call"><strong>Usuario: </strong>{{ documentNumber }}</p>
    <div class="circle" (click)="closeSession()">
      <app-icons [type]="'close'"></app-icons>
    </div>
  </div>
</section>
